import type {Guest} from '~/ViewInvitation/types/guests';
import {Divider} from '~library/atoms/Divider';
import {Typography} from '~library/atoms/Typography';
import {useIsLargeAndUp} from '~library/hooks/useMatchQuery';
import {MOBILE_VIEWS, ResponsivePanel} from '~library/organisms/ResponsivePanel';

interface PollChoiceOverlayProps {
  open: boolean;
  onClose: () => void;
  choice: string;
  guests?: Guest[];
}

export const PollChoiceOverlay = ({open, onClose, choice, guests = []}: PollChoiceOverlayProps) => {
  const isLargeAndUp = useIsLargeAndUp();

  const generateGuestInitials = (guest: Guest): string => {
    if (guest?.name.indexOf(' ') >= 0) {
      return guest?.name
        .replace(/[^a-zA-Z ]/g, '')
        .split(' ')
        .map((word) => word[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
    }
    return (
      guest?.name
        .match(/[a-zA-Z]/)
        ?.pop()
        ?.toUpperCase() || ''
    );
  };

  return (
    <ResponsivePanel
      title={`${choice} (${guests.length})`}
      isOpen={open}
      portalMode={true}
      onClose={onClose}
      showCover={true}
      renderMobileViewAs={MOBILE_VIEWS.BOTTOM_SHEET}
    >
      {isLargeAndUp && <Divider />}
      <div>
        {guests?.map((guest) => (
          <div
            key={guest?.userId}
            className="poll-choice-slideout__guest"
            data-qa-id="settings-overlay__poll-list__guest"
          >
            <div className="poll-choice-slideout__guest-initials">
              {generateGuestInitials(guest)}
            </div>
            <Typography variant="paragraph2" data-qa-id="settings-overlay__poll-list__guest-name">
              {guest?.name || ''}
            </Typography>
          </div>
        ))}
      </div>
    </ResponsivePanel>
  );
};
